import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import PracticalInformation from './PracticalInformation';
import ChooseObject from './ChooseObject';
import GetCosts from './GetCosts';
import GetUserDetails from './GetUserDetails';
import GetObjectDetails from './GetObjectDetails';
import LeafletMap from './LeafletMap';
import UploadDocuments from './UploadDocuments';
import Finish from './Finish';

const routes = [
  {
    path: '/',
    exact: true,
    component: PracticalInformation, 
  },
  {
    path: '/ChooseObject',
    exact: true,
    component: ChooseObject,
  },
  {
    path: '/GetCosts',
    exact: true,
    component: GetCosts, 
  },
  {
    path: '/LeafletMap',
    exact: true,
    component: LeafletMap,
  },
  {
    path: '/GetObjectDetails',
    exact: true,
    component: GetObjectDetails,
  },
  {
    path: '/GetUserDetails',
    exact: true,
    component: GetUserDetails,
  },
  {
    path: '/UploadDocuments',
    exact: true,
    component: UploadDocuments,
  },
  {
    path: '/Finish',
    exact: true,
    component: Finish,
  },
];

export default ({ match, ...props }) => (
  <Switch>
    {routes.map((route, i) => {
      return (                                
        <Route
          key={i}
          exact={route.exact}
          path={`${match.url}${route.path}`}
          component={route.component} />
      )})}
  </Switch>
);
